import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular/lazy';
import { ModalePrivacyDocPage, PrivacyDocType } from '../modali/modale-privacy-doc/modale-privacy-doc.page';

@Component({
  selector: 'privacy-data',
  templateUrl: './privacy-data.component.html',
  styleUrls: ['./privacy-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PrivacyDataComponent {
  @Input() customTextOne: string;
  @Input() customTextTwo: string;
  @Input() otherText: string;
  @Input() paginaProvenienza: string = 'signup';
  @Input() openInModal: boolean = false;

  constructor(
    private router: Router,
    private modalCtrl: ModalController
  ) { }

  openTrattamento() {
    this.openDoc('trattamento', '/trattamentodati');
  }

  openFinalita() {
    this.openDoc('finalita', '/finalitadati');
  }

  private async openDoc(docType: PrivacyDocType, route: string) {
    if (!this.openInModal) {
      this.router.navigate([route]);
      return;
    }
    const modal = await this.modalCtrl.create({
      component: ModalePrivacyDocPage,
      componentProps: { docType },
      cssClass: 'modale-privacy-doc'
    });
    await modal.present();
  }
}
